module.exports = __webpack_public_path__ + "img/bank-transfer-sm.e45feb5a.png";